interface StatCardProps {
  label: string;
  value: string | number;
  hint?: string;
  accent?: 'blue' | 'teal' | 'amber' | 'violet' | 'rose' | 'slate';
}

const accentStyles: Record<NonNullable<StatCardProps['accent']>, string> = {
  blue: 'bg-blue-50 text-blue-700 ring-blue-100',
  teal: 'bg-teal-50 text-teal-700 ring-teal-100',
  amber: 'bg-amber-50 text-amber-700 ring-amber-100',
  violet: 'bg-violet-50 text-violet-700 ring-violet-100',
  rose: 'bg-rose-50 text-rose-700 ring-rose-100',
  slate: 'bg-slate-50 text-slate-700 ring-slate-100',
};

export default function StatCard({ label, value, hint, accent = 'blue' }: StatCardProps) {
  return (
    <div className="rounded-xl border border-slate-100 bg-white p-5 shadow-sm">
      <p className="text-xs font-medium text-slate-500">{label}</p>
      <div className="mt-2 flex items-end justify-between gap-3">
        <p className="text-2xl font-bold tracking-tight text-slate-900">{value}</p>
        {hint && (
          <span className={`rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset ${accentStyles[accent]}`}>
            {hint}
          </span>
        )}
      </div>
    </div>
  );
}
